// see https://vuejsdevelopers.com/2020/01/06/handling-events-vue-js/ for eventBus concept
import Vue from 'vue';
export default new Vue();
